import React from "react";
import Slider from "./Slider/Slider";
import Welcome from "./Welcome/Welcome";
import Specialities from "./specialities/Specialities";
import Doctors from "./doctors/Doctors";
import Testimonials from "./testimonials/Testimonials";
import DepartmentsHome from "./departments/DepartmentsHome";
import HealthPackages from "./healthpackages/HealthPackages";
import DialysisMarquee from "./Pages/DialysisMArquee";
import Slider1 from "./Slider/Slider1";
import Slider2 from "./Slider/Slider2";


function Blog() {
  return (
    <>
    {/* <DialysisMarquee/> */}
      <Slider />
      {/* <Slider1/> */}
      {/* <Slider2/> */}
      <Welcome />
      <Doctors />
      <Specialities />
      <DepartmentsHome />
      <HealthPackages />
      <Testimonials/>
    </>
  );
}

export default Blog;
